import { weenatIntl } from '@weenat/wintl';
function getMetricNameForSelector(metric) {
    let name = '';
    switch (metric) {
        case 'FF':
            name = weenatIntl.t(`metrics.FF_abbr`, { capitalize: true });
            break;
        case 'U_CAPA':
            name = weenatIntl.t(`metric_selector.CAPA`, { capitalize: true });
            break;
        case 'HPOT':
            name = weenatIntl.t(`metric_selector.HPOT`, { capitalize: true });
            break;
        default:
            name = weenatIntl.t(`metrics.${metric}`, { capitalize: true });
            break;
    }
    return name;
}
export default getMetricNameForSelector;
